import { render, staticRenderFns } from "./OfferTab.vue?vue&type=template&id=d7223060&scoped=true"
import script from "./OfferTab.vue?vue&type=script&lang=js"
export * from "./OfferTab.vue?vue&type=script&lang=js"
import style0 from "./OfferTab.vue?vue&type=style&index=0&id=d7223060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7223060",
  null
  
)

export default component.exports